import { sendGoogleAnalyticsEvents } from '@elfsight/lib-google-analytics';
import type { ButtonProps } from '@elfsight/widget-ui';
import { Button } from '@elfsight/widget-ui';
import { useTranslation } from 'react-i18next';
import { getSourceMetaValue } from '../../../constants';
import { useSocialFeedSettings } from '../../utils';
import { usePost } from '../Post';
import { usePostSettings } from '../utils';

const FOLLOW_BUTTON_STYLES: ButtonProps = {
  mode: 'outline',
  borderRadius: 100,
  verticalPadding: 7,
  horizontalPadding: 9,
  lineHeight: 1.09,
  overlayOpacityOnHover: 0,
  font: {
    fontSize: 11,
    fontWeight: 'bold'
  }
};

export function FollowButton() {
  const { t } = useTranslation();
  const {
    id,
    followButtonLink,
    source: { type: platform, url: postUrl = '' }
  } = usePost();
  const { followButtonColor } = usePostSettings();
  const {
    googleAnalytics = [],
    widgetId = '',
    editMode
  } = useSocialFeedSettings();

  const { followButtonText } = getSourceMetaValue(platform);

  const handleClick = () => {
    sendGoogleAnalyticsEvents({
      eventType: 'socialPlatformOpened',
      googleAnalyticsEvents: googleAnalytics,
      editMode,
      valueMapping: {
        widgetId,
        postId: id,
        postUrl,
        entryPoint: 'post'
      }
    });

    window.open(followButtonLink, '_blank');
  };

  if (!followButtonLink || !followButtonText) return null;

  return (
    <Button
      {...FOLLOW_BUTTON_STYLES}
      text={t(followButtonText)}
      color={followButtonColor}
      onClick={handleClick}
    />
  );
}
